import { Amplify, Auth, Logger } from 'aws-amplify';
import {awsRegion} from '@/config';
import AWS from 'aws-sdk';

const logger = new Logger('credenciales AWS', 'WARN');

export default function(){
	logger.info('configurando credenciales')
	return Auth.currentCredentials().then(credentials=>{
		logger.info('credentials', credentials)
		AWS.config.update({
			credentials: Auth.essentialCredentials(credentials),
			region: awsRegion,
			maxRetries: 2,
			httpOptions: {
				timeout: 15*60*1000,
				connectTimeout: 15*60*1000
			}
		});
		logger.info('credenciales configuradas exitosamente')
	}).catch(err=>{
		logger.error('error al configurar credenciales', err)
	})
}